import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Dictionary, ReadonlyHttpApiListRepository } from '@softline/core';
import {
  SOFTLINE_API_MDE_STOCK_ITEM,
  SOFTLINE_API_MDE_STOCK_ITEM_PATCH,
} from '../einseitige-lagerbuchung.api';
import { Item } from '../models/item';
import { StockPostingQuery } from '../models/stock-posting-query';

@Injectable()
export class ItemRepository extends ReadonlyHttpApiListRepository<
  Item[],
  StockPostingQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_MDE_STOCK_ITEM);
  }

  override getLoadPathParams(params: StockPostingQuery): Dictionary<unknown> {
    return { id: params.id };
  }

  async patch(id, itemId, body) {
    return await this.dataAccess.patch(
      {
        path: SOFTLINE_API_MDE_STOCK_ITEM_PATCH,
        pathParams: { id: id, itemId: itemId },
      },
      body
    );
  }

  async create(id, body) {
    return await this.dataAccess.create(
      {
        path: this.path,
        pathParams: { id: id },
      },
      body
    );
  }

  async delete(id, itemId) {
    return await this.dataAccess.delete({
      path: SOFTLINE_API_MDE_STOCK_ITEM_PATCH,
      pathParams: { id: id, itemId: itemId },
    });
  }
}
